<template>
  <div>
    <PageHeaderUI
      :back="true"
      title="Quotes & Drafts"
      breadcrumb="Booking & Shipments > Quotes & Drafts > Get New Quote"
    />
    <KeepAlive>
      <component :is="currentTab" @changeTabs="changeTabs"></component>
    </KeepAlive>
  </div>
</template>

<script>
import PageHeaderUI from "../UI/PageHeaderUI.vue";
import NewQuoteAndDraft from "./NewQuoteAndDraft.vue";
import DescribeShipping from "./DescribeShippment.vue";
import QuoteRefrence from "./QuoteRefrence.vue";

export default {
  data() {
    return {
      Tab: "new-quote",
    };
  },
  components: {
    PageHeaderUI,
    NewQuoteAndDraft,
    DescribeShipping,
    QuoteRefrence,
  },
  computed: {
    currentTab() {
      let tab;
      switch (this.Tab) {
        case "new-quote":
          tab = "new-quote-and-draft";
          break;
        case "describe-shipping":
          tab = "describe-shipping";
          break;
        case "summary":
          tab = "quote-refrence";
          break;

        default:
          tab = "new-quote-and-draft";
          break;
      }
      return tab;
    },
  },
  methods: {
    changeTabs(val) {
      this.Tab = val;
    },
  },
};
</script>

<style lang="scss" scoped></style>
